import React, { FC } from "react";

import useMediaQuery from "../../hooks/useMediaQuery";
import { Drawer, DrawerProps } from "../Drawer/Drawer";
import { Modal, ModalProps } from "../Modal/Modal";

export type IResponsiveModalProps = ModalProps | DrawerProps;

export const ResponsiveModal: FC<IResponsiveModalProps> = ({
  children,
  ...props
}) => {
  const { isMobile } = useMediaQuery();

  if (isMobile)
    return (
      <Drawer placement="bottom" {...props}>
        {children}
      </Drawer>
    );

  return (
    <Modal isCentered {...props}>
      {children}
    </Modal>
  );
};
